import _has from 'lodash/has';
import _find from 'lodash/find';
import _each from 'lodash/each';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $q, $state, $stateParams, $timeout, metaTagService, jsSdkReview, utilsService, loggerService, tracking) {
  $scope.loading = true;
  $scope.valid = true;
  $scope.responses = ['I hated it', 'I didn\'t like it', 'It was ok', 'I liked it', 'I loved it!'];
  $scope.review = {};
  $scope.booking = {};

  metaTagService.set({
    title: 'Your Review | Tablelist',
    description: 'Review your night to help others learn about great nightlife venues.'
  });

  const reviewId = $stateParams.reviewId;

  $q.all([$scope.bookingsPromise, $scope.reviewsPromise])
    .then(function success(values) {
      const bookings = values[0];
      const reviews = ($scope.reviews.length > 0) ? $scope.reviews : values[1];

      $scope.review = _find(reviews, {
        id: reviewId
      });

      $scope.booking = _find(bookings, {
        id: $scope.review.booking
      });

      _each($scope.review.questions, function(question) {
        question.valid = true;
        question.disableResponses = false;
      });

      $scope.loading = false;
    }, error);

  $scope.respondToQuestion = function(key, rating) {
    const question = _find($scope.review.questions, {
      key: key
    });

    if (question.disableResponses) return;

    question.disableResponses = true;
    question.rating = rating;
    question.spin = rating;

    $timeout(function() {
      question.spin = -1;
      question.disableResponses = false;
    }, 350);
  };

  $scope.validate = function() {
    let valid = true;

    _each($scope.review.questions, function(question) {
      question.valid = (_has(question, 'rating') && typeof question.rating === 'number');
      if (!question.valid) valid = false;
    });

    $scope.valid = valid;

    return valid;
  };

  $scope.submitForm = function() {
    if (!$scope.validate()) return;

    const data = {};

    if (_has($scope.review, 'comment')) {
      if (!$scope.review.comment) {
        delete $scope.review.comment;
      } else {
        data.comment = $scope.review.comment;
      }
    }

    const questions = [];

    _each($scope.review.questions, function(question) {
      questions.push({
        key: (_has(question, 'key') && typeof question.key === 'number') ? question.key : -1,
        rating: (_has(question, 'rating') && typeof question.rating === 'number') ? question.rating : -1
      });
    });

    data.questions = questions;

    jsSdkReview.update($scope.review.id, data)
      .then(resp => {
        $scope.review.pending = false;
        $scope.$parent.pendingReviewCount -= 1;

        const trackingData = {
          reviewId: resp.id,
          venueId: resp.venue,
          bookingId: resp.booking
        };

        tracking.trackEvent(SEGMENT_EVENTS.SubmittedReview, trackingData);

        $state.go('app.me.reviews');
      }, error);
  };

  function error(response) {
    $scope.errorMsg = utilsService.errorMessage(response);
    loggerService.error(response);
  }
}

Ctrl.$inject = [
  '$scope',
  '$q',
  '$state',
  '$stateParams',
  '$timeout',
  'metaTagService',
  'jsSdk.review',
  'utilsService',
  'loggerService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/accountReview/accountReviewCtrl.js